import styled, { css } from 'styled-components';
import { token } from '@zillow/constellation';

const SPACING_IN_PX = {
    Y: 25,
    X: 28,
};

type ZillowNavbarSubSectionContainerProps = {
    isVertical: boolean;
};
export const ZillowNavbarSubSectionContainer = styled.li<ZillowNavbarSubSectionContainerProps>`
    padding-left: 0px;
    display: inline-block;
    ${({ isVertical }) =>
        isVertical
            ? css`
                  padding-top: ${SPACING_IN_PX.Y}px;
                  padding-bottom: ${SPACING_IN_PX.Y}px;
              `
            : css`
                  margin-top: ${SPACING_IN_PX.Y}px;
                  padding-right: ${SPACING_IN_PX.X}px;
                  margin-bottom: ${SPACING_IN_PX.Y}px;
              `};
    ${({ isVertical }) =>
        isVertical
            ? css`
                  && + && {
                      border-top: 1px solid ${token('colors.borderLight')};
                  }
              `
            : css`
                  && + && {
                      border-left: 1px solid ${token('colors.borderLight')};
                      padding-left: ${SPACING_IN_PX.X}px;
                  }
              `}
`;
